var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "gis-wrap" }, [
    _vm.settings.settings &&
    _vm.settings.settings.hide_on_valid &&
    _vm.integration.status
      ? _c("div", { staticClass: "gis-card" }, [
          _c("div", { staticClass: "gis-card__head" }, [
            _c("h2", { staticClass: "gis-card__title" }, [
              _vm._v(_vm._s(_vm.settings.title))
            ]),
            _vm._v(" "),
            _c("p", {
              staticClass: "gis-card__desc",
              domProps: { innerHTML: _vm._s(_vm.settings.description) }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "gis-connected" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("h3", {
              staticClass: "gis-connected__title",
              domProps: {
                innerHTML: _vm._s(
                  _vm.settings.settings.discard_settings.section_description
                )
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "gis-connected__actions" },
              [
                _vm.settings.settings.discard_settings.show_verify
                  ? _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.saving,
                            expression: "saving"
                          }
                        ],
                        attrs: {
                          type: "primary",
                          size: "small",
                          icon: "el-icon-refresh"
                        },
                        on: { click: _vm.save }
                      },
                      [_vm._v("Verify Again")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "danger", size: "small", plain: "" },
                    on: {
                      click: function($event) {
                        return _vm.disconnect(
                          _vm.settings.settings.discard_settings.data
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.settings.settings.discard_settings.button_text)
                    )
                  ]
                )
              ],
              1
            )
          ])
        ])
      : _c(
          "div",
          { staticClass: "gis-card" },
          [
            _c("div", { staticClass: "gis-card__head" }, [
              _c("div", { staticClass: "gis-card__head-row" }, [
                _c("div", [
                  _c("h2", { staticClass: "gis-card__title" }, [
                    _vm._v(_vm._s(_vm.settings.title))
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "gis-card__desc",
                    domProps: { innerHTML: _vm._s(_vm.settings.description) }
                  })
                ]),
                _vm._v(" "),
                _vm.settings.settings
                  ? _c(
                      "span",
                      {
                        staticClass: "gis-status-badge",
                        class: _vm.integration.status
                          ? "gis-status-badge--on"
                          : "gis-status-badge--off"
                      },
                      [
                        _c("span", {
                          staticClass: "dashicons",
                          class: _vm.integration.status
                            ? "dashicons-yes-alt"
                            : "dashicons-warning"
                        }),
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.integration.status
                                ? "Connected"
                                : "Not Connected"
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c(
              "el-skeleton",
              { attrs: { loading: _vm.loading, animated: "", rows: 6 } },
              [
                _c(
                  "el-form",
                  {
                    staticClass: "gis-form",
                    attrs: { "label-position": "top" }
                  },
                  [
                    _vm._l(
                      _vm.settings.settings && _vm.settings.settings.fields
                        ? _vm.settings.settings.fields
                        : [],
                      function(field, fieldKey) {
                        return _c(
                          "el-form-item",
                          { key: fieldKey, staticClass: "gis-form__item" },
                          [
                            field.label
                              ? _c("template", { slot: "label" }, [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(field.label) +
                                      "\n          "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            field.type === "text" || field.type === "number"
                              ? _c("el-input", {
                                  attrs: {
                                    type: field.type,
                                    placeholder: field.placeholder
                                  },
                                  model: {
                                    value: _vm.integration[field.name],
                                    callback: function($$v) {
                                      _vm.$set(_vm.integration, field.name, $$v)
                                    },
                                    expression: "integration[field.name]"
                                  }
                                })
                              : field.type === "password"
                              ? _c("el-input", {
                                  attrs: {
                                    type: "password",
                                    placeholder: field.placeholder,
                                    "show-password": ""
                                  },
                                  model: {
                                    value: _vm.integration[field.name],
                                    callback: function($$v) {
                                      _vm.$set(_vm.integration, field.name, $$v)
                                    },
                                    expression: "integration[field.name]"
                                  }
                                })
                              : field.type === "textarea"
                              ? _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    rows: 3,
                                    placeholder: field.placeholder
                                  },
                                  model: {
                                    value: _vm.integration[field.name],
                                    callback: function($$v) {
                                      _vm.$set(_vm.integration, field.name, $$v)
                                    },
                                    expression: "integration[field.name]"
                                  }
                                })
                              : field.type === "select"
                              ? _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    model: {
                                      value: _vm.integration[field.name],
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.integration,
                                          field.name,
                                          $$v
                                        )
                                      },
                                      expression: "integration[field.name]"
                                    }
                                  },
                                  _vm._l(field.options, function(
                                    optionName,
                                    optionValue
                                  ) {
                                    return _c("el-option", {
                                      key: optionValue,
                                      attrs: {
                                        label: optionName,
                                        value: optionValue
                                      }
                                    })
                                  }),
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            field.tips
                              ? _c("p", { staticClass: "gis-form__tip" }, [
                                  _vm._v(_vm._s(field.tips))
                                ])
                              : _vm._e()
                          ],
                          2
                        )
                      }
                    ),
                    _vm._v(" "),
                    _vm.settings.settings
                      ? _c("div", { staticClass: "gis-validation" }, [
                          _vm.integration.status
                            ? _c("div", { staticClass: "gis-validation--ok" }, [
                                _c("span", {
                                  staticClass: "dashicons dashicons-yes-alt"
                                }),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.settings.settings.valid_message
                                    ) +
                                    "\n          "
                                )
                              ])
                            : _c(
                                "div",
                                { staticClass: "gis-validation--err" },
                                [
                                  _c("span", {
                                    staticClass: "dashicons dashicons-warning"
                                  }),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.settings.settings.invalid_message
                                      ) +
                                      "\n          "
                                  )
                                ]
                              )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.error_message
                      ? _c("p", { staticClass: "gis-error" }, [
                          _vm._v(_vm._s(_vm.error_message))
                        ])
                      : _vm._e()
                  ],
                  2
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "gis-card__footer" },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.saving,
                        expression: "saving"
                      }
                    ],
                    attrs: { type: "primary", icon: "el-icon-check" },
                    on: { click: _vm.save }
                  },
                  [_vm._v("Save Settings")]
                )
              ],
              1
            )
          ],
          1
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gis-connected__icon" }, [
      _c("span", { staticClass: "dashicons dashicons-yes-alt" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }